import { Component, OnInit } from '@angular/core';
import { GlobalService } from 'src/app/shared/global.service';
import { UrlService } from 'src/app/shared/services/url.service';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { AlertService } from 'src/app/shared/services/alert.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { IngresoActivoFijoFuncionario } from 'src/app/models/RegistroActivoFijoFuncionario.model';
import { Router } from '@angular/router';
import { VariablesZonaCompartida } from 'src/app/shared/services/VariablesZonaCompartida';

@Component({
  selector: 'app-funcionario',
  templateUrl: './funcionario.component.html',
  styleUrls: ['./funcionario.component.scss']
})
export class FuncionarioComponent implements OnInit {

  listaFuncionarios: IngresoActivoFijoFuncionario[];
  url: string;
  filtroNombre: string;

  constructor(
    private globalService: GlobalService, private urlService: UrlService,
    private alertService: AlertService, private spinner: NgxSpinnerService,
    private router: Router) {
    this.url = '';
  }

  ngOnInit() {
    this.consultarFuncionariosConRegistro();
  }

  realizarRegistro(event: any) {
    this.globalService.zonaCompartida[VariablesZonaCompartida.DATOS_FUNCIONARIO_ACTIVO_FIJO] = {
      objeto: JSON.stringify(event.objeto),
      tipo: event.tipo
    };
    this.router.navigate(['/main/funcionario/registro']);
  }

  buscarPorFiltro() {
    if (this.filtroNombre && this.filtroNombre!='') {
      if (this.validarCaracteresFiltro(this.filtroNombre)) {
        this.consultarFuncionariosConRegistro(this.filtroNombre, null);
      } else {
        this.consultarFuncionariosConRegistro(null, this.filtroNombre);
      }
    }else{
      this.alertService.generateAlertError('Ingrese un Número de documento o Nombre de funcionario válido', '');
    }
  }

  consultarFuncionariosConRegistro(numeroId?: string, nombre?: string) {
    this.listaFuncionarios = [];
    this.spinner.show();
    const serviceProvider = 'Funcionario';
    const queryParams: Array<[string, string]> = new Array<[string, string]>();

    if (numeroId) {
      queryParams.push(['numeroId', numeroId]);
    }
    if (nombre) {
      queryParams.push(['nombre', nombre]);
    }

    const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_ACCVIS);
    this.globalService.getGenerico(url)
      .subscribe((dataFuncionario: IngresoActivoFijoFuncionario[]) => {
        if (dataFuncionario.length > 0) {
          this.listaFuncionarios = dataFuncionario;
        } else {
          if(numeroId){
            this.alertService.generateAlertError('El número de documento consultado no corresponde a un funcionario del MEN, por favor verifique', '');
          }
          if(nombre){
            this.alertService.generateAlertError('El nombre consultado no corresponde a un funcionario del MEN, por favor verifique', '');
          }
        }
        this.spinner.hide();
      }, error => {
        this.cathException(error);
      });
  }

  FiltroBusqueda(event: any) {
    this.FiltroBusqueda = event;
  }

  cathException(error) {
    this.alertService.generateAlertError(error, 'Error');
    this.spinner.hide();
  }

  validarCaracteresFiltro(valor: string): boolean {
    const numeros = '0123456789';
    for (let i = 0; i < valor.length; i++) {
      if (numeros.indexOf(valor.charAt(i), 0) !== -1) {
        return true;
      }
    }

    return false;
  }
}
